/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  function swymCallbackFn(swat) {
    var counter_elem =
      document.querySelectorAll(
        ".swym-wish-counter"
      ); /* Custom header can be added here.*/
    if (counter_elem) {
      for (var i = 0; i < counter_elem.length; i++) {
        if (swat.renderWishlistCount) {
          swat.renderWishlistCount(counter_elem[i]);
        }
      }
    }

    window.addEventListener("custom:initialize-swym", (e) => {
      swat.initializeActionButtons(e.detail.selector);
    });
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);

  window.addEventListener(
    "unload",
    function () {
      document.querySelectorAll("form").forEach((form) => form.reset());
    },
    false
  );

  window.reinitReviews = () => {
    if (window.Yotpo) {
      document.querySelectorAll(".yotpo.bottomLine").forEach((ybl) => {
        const content = ybl.innerHTML;
        if (content) {
          const replacement = document.createElement("div");
          replacement.classList.add("yotpo");
          replacement.innerHTML = content;
          ybl.parentElement.replaceChild(replacement, ybl);
        }
      });
      try {
        new Yotpo.API(yotpo).refreshWidgets();
      } catch(err) {
        console.log(err)
      }
    }
  };

  // (function getBreadcrumb() {
  //   const pathname = window.location.pathname;
  //   const includesCollection = pathname.includes("/collection/");
  //   const includesProduct = pathname.includes("/products/");
  //   if (
  //     (includesCollection && includesProduct) ||
  //     (!includesCollection && !includesProduct)
  //   ) {
  //     sessionStorage.removeItem("referrer-collection");
  //   } else if (includesCollection && !includesProduct) {
  //     sessionStorage.setItem(
  //       "referrer-collection",
  //       JSON.stringify({
  //         handle: window.location.pathname.split("/collections/")[1],
  //         title: document
  //           .querySelector('meta[property="og:title"]')
  //           ?.getAttribute("content"),
  //       })
  //     );
  //   } else if (!includesCollection && includesProduct) {
  //   }
  // })();

  (function replaceGlobaleBanner() {
    let timeElapsed = 0;
    const interval = setInterval(() => {
      timeElapsed += 500;

      const globaleBanner = document.querySelector(
        ".ge-free-shipping-container"
      );
      if (globaleBanner) {
        const replacements = document.querySelectorAll(
          ".js-globale-replacement"
        );
        if (replacements.length) {
          let text = globaleBanner.innerText.trim();
          if ([",00", ".00"].includes(text.slice(text.length - 3))) {
            text = text.slice(0, text.length - 3);
          }
          replacements.forEach((replacement) => {
            replacement.innerText = text;
            replacement.classList.remove("js-globale-replacement");
          });
        } else if (!document.querySelector("[data-hide-globale]")) {
          globaleBanner.classList.add("--show");
        }
      }

      if (
        globaleBanner ||
        timeElapsed >= 10000 ||
        window.Shopify?.country === "US"
      ) {
        const replacements = document.querySelectorAll(
          ".js-globale-replacement"
        );
        replacements.forEach((replacement) => {
          replacement.classList.remove("js-globale-replacement");
        });
        clearInterval(interval);
      }
    }, 500);
  })();

  (function convertCurrencies() {
    document.querySelectorAll(".js-convert-currency").forEach((tag) => {
      const amount = Number(tag.dataset.amount);
      tag.innerText = window.formatMoney(
        Math.round(amount * window.Shopify.currency.rate)
      );
    });
  })();

  (function manageStickyHeaderSections() {
    let headerSections = Array.from(
      document.querySelectorAll('[data-section-location="header"]')
    ).map((section) => ({
      el: section,
      height: section.offsetHeight,
    }));

    let stickyHeaderSections = headerSections
      .map((section, idx) => {
        if (section.el.hasAttribute("data-sticky-header-section")) {
          return {
            ...section,
            minTopOffset: headerSections
              .slice(0, idx)
              .filter((s) => s.el.hasAttribute("data-sticky-header-section"))
              .reduce((acc, s) => acc + s.height, 0),
            defaultTopOffset: headerSections
              .slice(0, idx)
              .reduce((acc, s) => acc + s.height, 0),
          };
        }
      })
      .filter(Boolean);

    stickyHeaderSections.forEach((section) => {
      section.el.parentElement.style.minHeight = `${section.height}px`;
    });

    const adjustPlacements = () => {
      stickyHeaderSections.forEach((section) => {
        const el = section.el;
        if (
          el.getBoundingClientRect().top <= section.minTopOffset &&
          el.style.position !== "fixed"
        ) {
          el.style.position = "fixed";
          el.style.top = `${section.minTopOffset}px`;
          // el.style.zIndex = 200;
        } else if (
          window.scrollY < section.defaultTopOffset - section.minTopOffset &&
          el.style.position === "fixed"
        ) {
          el.style.position = "relative";
          el.style.top = "0px";
        }
      });
    };

    adjustPlacements();
    window.addEventListener("scroll", adjustPlacements);
  })();

  (function adjustMobileNavTopPosition() {
    const nav = document.querySelector(".drawer.drawer--nav");
    if (nav && document.querySelector("[data-announcement]")) {
      nav.classList.add("--lower");
    }
  })();

  // CUSTOM ELEMENTS BELOW:

  class CSWishlistBtn extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const uid = `cswb-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
      this.classList.add(uid);
      window.dispatchEvent(
        new CustomEvent("custom:initialize-swym", {
          detail: {
            selector: "." + uid,
          },
        })
      );
    }
  }

  customElements.define("cs-wishlist-button", CSWishlistBtn);

  const selectors$9Custom = {
    mediaContainer: "[data-product-single-media-group]",
    productMediaSlider: "[data-product-single-media-slider]",
    zoomWrapper: "[data-zoom-wrapper]",
  };

  const classes$9Custom = {
    popupClass: "pswp-zoom-gallery",
    popupClassNoThumbs: "pswp-zoom-gallery--single",
    isMoving: "is-moving",
  };

  const attributes$8Custom = {
    dataImageWidth: "data-image-width",
    dataImageHeight: "data-image-height",
  };

  class ZoomCustom {
    constructor(container) {
      this.container = container;
      this.mediaContainer = this.container.querySelector(
        selectors$9Custom.mediaContainer
      );
      this.slider = this.container.querySelector(
        selectors$9Custom.productMediaSlider
      );
      this.zoomWrappers = this.container.querySelectorAll(
        selectors$9Custom.zoomWrapper
      );
      this.zoomEnable = this.mediaContainer.dataset.gallery === "true";
      // this.a11y = a11y;

      if (this.zoomEnable) {
        this.init();
      }
    }

    init() {
      if (this.zoomWrappers.length) {
        this.zoomWrappers.forEach((element, i) => {
          element.addEventListener("click", (e) => {
            e.preventDefault();

            const isMoving =
              this.slider && this.slider.classList.contains(classes$9Custom.isMoving);

            if (!isMoving) {
              // this.a11y.state.trigger = element;
              this.createZoom(i);
            }
          });
        });
      }
    }

    createZoom(indexImage) {
      const instance = this;
      let items = [];
      let counter = 0;

      this.zoomWrappers.forEach((elementImage) => {
        const imgSrc = elementImage.getAttribute("href");
        const imgWidth = parseInt(
          elementImage.getAttribute(attributes$8Custom.dataImageWidth)
        );
        const imgHeight = parseInt(
          elementImage.getAttribute(attributes$8Custom.dataImageHeight)
        );

        items.push({
          src: imgSrc,
          w: imgWidth,
          h: imgHeight,
          msrc: imgSrc,
        });

        counter += 1;
        if (instance.zoomWrappers.length === counter) {
          let popupClass = `${classes$9Custom.popupClass}`;

          if (counter === 1) {
            popupClass = `${classes$9Custom.popupClass} ${classes$9Custom.popupClassNoThumbs}`;
          }
          const options = {
            barsSize: { top: 60, bottom: 60 },
            history: false,
            focus: false,
            index: indexImage,
            mainClass: popupClass,
            showHideOpacity: true,
            showAnimationDuration: 250,
            hideAnimationDuration: 250,
            closeOnScroll: false,
            closeOnVerticalDrag: false,
            captionEl: false,
            closeEl: true,
            closeElClasses: ["caption-close"],
            tapToClose: false,
            clickToCloseNonZoomable: false,
            maxSpreadZoom: 2,
            loop: true,
            spacing: 0,
            allowPanToNext: true,
            pinchToClose: false,
          };

          console.log("items: ", items)
          console.log("options: ", options)

          new LoadPhotoswipeCustom(items, options);
        }
      });
    }
  }

  const settings$5Custom = {
    unlockScrollDelay: 400,
  };

  const selectors$ICustom = {
    popupContainer: ".pswp",
    popupCloseBtn: ".pswp__custom-close",
    popupIframe: "iframe, video",
    popupCustomIframe: ".pswp__custom-iframe",
    popupThumbs: ".pswp__thumbs",
    popupButtons: ".pswp__button, .pswp__caption-close",
    product: "[data-product]",
    productJSON: "[data-product-json]",
  };

  const classes$zCustom = {
    current: "is-current",
    customLoader: "pswp--custom-loader",
    customOpen: "pswp--custom-opening",
    loader: "pswp__loader",
    opened: "pswp--open",
    popupCloseButton: "pswp__button--close",
    notificationPopup: "pswp--notification",
    quickviewPopup: "popup-quick-view",
    isCartDrawerOpen: "js-drawer-open-cart",
    quickViewAnimateOut: "popup-quick-view--animate-out",
  };

  const attributes$tCustom = {
    dataOptionClasses: "data-pswp-option-classes",
    dataVideoType: "data-video-type",
  };

  const loaderHTML = `<div class="${classes$zCustom.loader}"><div class="loader loader--image"><div class="loader__image"></div></div></div>`;

  class LoadPhotoswipeCustom {
    constructor(items, options = "", templateIndex = 0, triggerButton = null) {
      this.items = items;
      this.triggerBtn = triggerButton;
      this.pswpElements = document.querySelectorAll(selectors$ICustom.popupContainer);
      this.pswpElement = this.pswpElements[templateIndex];
      this.popup = null;
      this.popupThumbs = null;
      this.popupThumbsContainer = this.pswpElement.querySelector(
        selectors$ICustom.popupThumbs
      );
      this.closeBtn = this.pswpElement.querySelector(selectors$ICustom.popupCloseBtn);
      const defaultOptions = {
        history: false,
        focus: false,
        mainClass: "",
      };
      this.options = options !== "" ? options : defaultOptions;
      this.onCloseCallback = () => this.onClose();
      this.dispatchPopupInitEventCallback = () => this.dispatchPopupInitEvent();
      this.setCurrentThumbCallback = () => this.setCurrentThumb();
      // this.a11y = a11y;

      this.init();
    }

    init() {
      document.dispatchEvent(
        new CustomEvent("theme:scroll:lock", { bubbles: true })
      );

      this.pswpElement.classList.add(classes$zCustom.customOpen);

      this.initLoader();

      const loaders = {};

      function loadScript(options = {}) {
        if (!options.type) {
          options.type = "json";
        }
    
        if (options.url) {
          if (loaders[options.url]) {
            return loaders[options.url];
          } else {
            return getScriptWithPromise(options.url, options.type);
          }
        } else if (options.json) {
          if (loaders[options.json]) {
            return Promise.resolve(loaders[options.json]);
          } else {
            return window
              .fetch(options.json)
              .then((response) => {
                return response.json();
              })
              .then((response) => {
                loaders[options.json] = response;
                return response;
              });
          }
        } else if (options.name) {
          const key = "".concat(options.name, options.version);
          if (loaders[key]) {
            return loaders[key];
          } else {
            return loadShopifyWithPromise(options);
          }
        } else {
          return Promise.reject();
        }
      }

      function getScriptWithPromise(url, type) {
        const loader = new Promise((resolve, reject) => {
          if (type === "text") {
            fetch(url)
              .then((response) => response.text())
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            getScript(
              url,
              function () {
                resolve();
              },
              function () {
                reject();
              }
            );
          }
        });

        loaders[url] = loader;
        return loader;
      }

      function loadShopifyWithPromise(options) {
        const key = "".concat(options.name, options.version);
        const loader = new Promise((resolve, reject) => {
          try {
            window.Shopify.loadFeatures([
              {
                name: options.name,
                version: options.version,
                onLoad: (err) => {
                  onLoadFromShopify(resolve, reject, err);
                },
              },
            ]);
          } catch (err) {
            reject(err);
          }
        });
        loaders[key] = loader;
        return loader;
      }

      function getScript(url, callback, callbackError) {
        let head = document.getElementsByTagName("head")[0];
        let done = false;
        let script = document.createElement("script");
        script.src = url;
        script.defer = "defer";
    
        // Attach handlers for all browsers
        script.onload = script.onreadystatechange = function () {
          if (
            !done &&
            (!this.readyState ||
              this.readyState == "loaded" ||
              this.readyState == "complete")
          ) {
            done = true;
            callback();
          } else {
            callbackError();
          }
        };
    
        head.appendChild(script);
      }

      function onLoadFromShopify(resolve, reject, err) {
        if (err) {
          return reject(err);
        } else {
          return resolve();
        }
      }

      loadScript({ url: window.theme.assets.photoswipe })
        .then(() => this.loadPopup())
        .catch((e) => console.error(e));
    }

    initLoader() {
      if (
        this.pswpElement.classList.contains(classes$zCustom.customLoader) &&
        this.options !== "" &&
        this.options.mainClass
      ) {
        this.pswpElement.setAttribute(
          attributes$tCustom.dataOptionClasses,
          this.options.mainClass
        );
        let loaderElem = document.createElement("div");
        loaderElem.innerHTML = loaderHTML;
        loaderElem = loaderElem.firstChild;
        this.pswpElement.appendChild(loaderElem);
      } else {
        this.pswpElement.setAttribute(attributes$tCustom.dataOptionClasses, "");
      }
    }

    loadPopup() {
      const PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
      const PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;

      if (this.pswpElement.classList.contains(classes$zCustom.customLoader)) {
        this.pswpElement.classList.remove(classes$zCustom.customLoader);
      }

      this.pswpElement.classList.remove(classes$zCustom.customOpen);

      this.popup = new PhotoSwipe(
        this.pswpElement,
        PhotoSwipeUI,
        this.items,
        this.options
      );

      this.popup.listen("afterInit", this.dispatchPopupInitEventCallback);
      this.popup.listen("imageLoadComplete", this.setCurrentThumbCallback);
      this.popup.listen("beforeChange", this.setCurrentThumbCallback);
      this.popup.listen("close", this.onCloseCallback);

      this.popup.init();

      this.initPopupCallback();

      this.initSwatches()
    }

    initSwatches() {
      const swatches = this.pswpElement.querySelectorAll("[data-product-swatch]")
      
      swatches.forEach((swatch) => {
        swatch.addEventListener("click", (event) => {
          event.preventDefault()
          
          let quickViewVariant = "";

          if (swatch.hasAttribute(attributes$s.variantId)) {
            quickViewVariant = `&variant=${swatch.getAttribute(
              attributes$s.variantId
            )}`;
          }

          const productUrl = `${theme.routes.root}products/${swatch.getAttribute(
            attributes$s.handle
          )}?section_id=api-quickview${quickViewVariant}`;

          this.tryLoadPhotoswipeFromFetch = 0;
          this.loadPhotoswipeFromFetch(productUrl);
        });
      })
    }

    loadPhotoswipeFromFetch(url) {
      this.pswpElement.querySelector('.full-loader').style.display = "block";

      fetch(url)
        .then((response) => {
          return response.text();
        })
        .then((data) => {
          const items = [
            {
              html: data,
            },
          ];

          this.items = items;

          document.querySelector('#shopify-section-api-quickview').outerHTML = this.items[0].html;
          
          this.quickView.quickViewInner = this.quickView.pswpElement.querySelector(
            selectors$J.quickViewInner
          );

          this.quickView.quickViewInner.querySelector(
            selectors$J.popupClose
          ).addEventListener("click", (event) => {
            this.quickView.closePopup(event);
          });
        
          const item = this.pswpElement.querySelector('[data-product]');
          const index = 0;
    

          this.quickView.initItems(item, index);
          
          this.initSwatches()
          
          this.pswpElement.querySelector('.full-loader').style.display = "none";
        })
        .catch((error) => {
          console.log("error: ", error)

          if ( this.tryLoadPhotoswipeFromFetch === 3 ){
            this.pswpElement.querySelector('.full-loader').style.display = "none";
          } else {
            this.loadPhotoswipeFromFetch(url);
            this.tryLoadPhotoswipeFromFetch++;
          }
        });
    }

    initPopupCallback() {
      if (this.isVideo) {
        this.hideUnusedButtons();
      }

      this.initVideo();
      this.thumbsActions();

      // this.a11y.trapFocus({
      //   container: this.pswpElement,
      // });

      if (this.pswpElement.classList.contains(classes$zCustom.quickviewPopup)) {
        this.quickView = new LoadQuickview(this.popup, this.pswpElement);
      }

      if (this.pswpElement.classList.contains(classes$zCustom.notificationPopup)) {
        new LoadNotification(this.popup, this.pswpElement);
      }

      this.closePopup = () => {
        if (this.pswpElement.classList.contains(classes$zCustom.quickviewPopup)) {
          this.pswpElement.classList.add(classes$zCustom.quickViewAnimateOut); // Close the Quickview popup accordingly
        } else {
          this.popup.close();
        }
      };

      if (this.closeBtn) {
        this.closeBtn.addEventListener("click", this.closePopup);
      }

      // Close Quick view popup when product added to cart
      document.addEventListener("theme:cart:added", this.closePopup);
    }

    dispatchPopupInitEvent() {
      if (this.triggerBtn) {
        this.triggerBtn.dispatchEvent(
          new CustomEvent("theme:popup:init", { bubbles: true })
        );
      }
    }

    initVideo() {
      const videoContainer = this.pswpElement.querySelector(
        selectors$ICustom.popupCustomIframe
      );
      if (videoContainer) {
        const videoType = videoContainer.getAttribute(
          attributes$tCustom.dataVideoType
        );
        this.isVideo = true;

        if (videoType == "youtube") {
          new LoadVideoYT(videoContainer.parentElement);
        } else if (videoType == "vimeo") {
          new LoadVideoVimeo(videoContainer.parentElement);
        }
      }
    }

    thumbsActions() {
      if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild) {
        this.popupThumbsContainer.addEventListener("wheel", (e) =>
          this.stopDisabledScroll(e)
        );
        this.popupThumbsContainer.addEventListener("mousewheel", (e) =>
          this.stopDisabledScroll(e)
        );
        this.popupThumbsContainer.addEventListener("DOMMouseScroll", (e) =>
          this.stopDisabledScroll(e)
        );

        this.popupThumbs = this.pswpElement.querySelectorAll(
          `${selectors$ICustom.popupThumbs} > *`
        );
        this.popupThumbs.forEach((element, i) => {
          element.addEventListener("click", (e) => {
            e.preventDefault();
            element.parentElement
              .querySelector(`.${classes$zCustom.current}`)
              .classList.remove(classes$zCustom.current);
            element.classList.add(classes$zCustom.current);
            this.popup.goTo(i);
          });
        });
      }
    }

    hideUnusedButtons() {
      const buttons = this.pswpElement.querySelectorAll(
        selectors$ICustom.popupButtons
      );
      buttons.forEach((element) => {
        if (!element.classList.contains(classes$zCustom.popupCloseButton)) {
          element.style.display = "none";
        }
      });
    }

    stopDisabledScroll(e) {
      e.stopPropagation();
    }

    onClose() {
      const popupIframe = this.pswpElement.querySelector(
        selectors$ICustom.popupIframe
      );
      if (popupIframe) {
        popupIframe.parentNode.removeChild(popupIframe);
      }

      if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild) {
        while (this.popupThumbsContainer.firstChild) {
          this.popupThumbsContainer.removeChild(
            this.popupThumbsContainer.firstChild
          );
        }
      }

      this.pswpElement.setAttribute(attributes$tCustom.dataOptionClasses, "");
      const loaderElem = this.pswpElement.querySelector(`.${classes$zCustom.loader}`);
      if (loaderElem) {
        this.pswpElement.removeChild(loaderElem);
      }

      if (!document.body.classList.contains(classes$zCustom.isCartDrawerOpen)) {
        // this.a11y.removeTrapFocus();
      }

      document.removeEventListener("theme:cart:added", this.closePopup);

      // Unlock scroll if only cart drawer is closed and there are no more popups opened
      setTimeout(() => {
        const recentlyOpenedPopups = this.recentlyOpenedPopupsCount();
        const isCartDrawerOpen = document.body.classList.contains(
          classes$zCustom.isCartDrawerOpen
        );

        if (recentlyOpenedPopups === 0 && !isCartDrawerOpen) {
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: true })
          );
        }
      }, settings$5Custom.unlockScrollDelay);
    }

    recentlyOpenedPopupsCount() {
      let count = 0;

      this.pswpElements.forEach((popup) => {
        const isOpened = popup.classList.contains(classes$zCustom.opened);

        if (isOpened) {
          count += 1;
        }
      });

      return count;
    }

    setCurrentThumb() {
      const hasThumbnails =
        this.popupThumbsContainer && this.popupThumbsContainer.firstChild;

      if (hasThumbnails) return;

      const lastCurrentThumb = this.pswpElement.querySelector(
        `${selectors$ICustom.popupThumbs} > .${classes$zCustom.current}`
      );
      if (lastCurrentThumb) {
        lastCurrentThumb.classList.remove(classes$zCustom.current);
      }

      if (!this.popupThumbs) {
        return;
      }
      const currentThumb = this.popupThumbs[this.popup.getCurrentIndex()];
      currentThumb.classList.add(classes$zCustom.current);
      this.scrollThumbs(currentThumb);
    }

    scrollThumbs(currentThumb) {
      const thumbsContainerLeft = this.popupThumbsContainer.scrollLeft;
      const thumbsContainerWidth = this.popupThumbsContainer.offsetWidth;
      const thumbsContainerPos = thumbsContainerLeft + thumbsContainerWidth;
      const currentThumbLeft = currentThumb.offsetLeft;
      const currentThumbWidth = currentThumb.offsetWidth;
      const currentThumbPos = currentThumbLeft + currentThumbWidth;

      if (
        thumbsContainerPos <= currentThumbPos ||
        thumbsContainerPos > currentThumbLeft
      ) {
        const currentThumbMarginLeft = parseInt(
          window.getComputedStyle(currentThumb).marginLeft
        );
        this.popupThumbsContainer.scrollTo({
          top: 0,
          left: currentThumbLeft - currentThumbMarginLeft,
          behavior: "smooth",
        });
      }
    }
  }

  class ATCForm extends HTMLElement {
    constructor(bundle) {
      super();
      if (!bundle) {
        this.variantSelector = this.querySelector("select[name=id]");
        this.stickyVariantSelector = this.querySelector("[data-sticky-atc] select[name=id]");
        this.variantSelector = {
          self: this.variantSelector,
          options: this.variantSelector
            ? Array.from(this.variantSelector.querySelectorAll("option"))
            : null,
        };
        this.stickyVariantSelector = {
          self: this.stickyVariantSelector,
          options: this.stickyVariantSelector
            ? Array.from(this.stickyVariantSelector.querySelectorAll("option"))
            : null,
        };

        // Product options in squares
        this.variantSquareOptions = this.querySelectorAll("input[type=radio][name=id]");
      }

      this.atcButton = this.querySelector("button[type=submit]");
      this.stickyAtcButton = this.querySelector("[data-sticky-atc] button[type=button]");
      this.bisButton = this.querySelector("button[data-bis-button]");
      this.bisPopup = this.querySelector("[data-bis-popup]");
      this.wrapper = this.closest(".form__wrapper");
      this.form = this.wrapper?.querySelector("form");
      this.wishlistButton = this.closest(
        ".product-single__wrapper"
      )?.querySelector("cs-wishlist-button");
      this.remainingStockWrapper = this.wrapper?.querySelector(
        "[data-remaining-wrapper]"
      );
      this.priceWrappers = Array.from(
        this.wrapper?.querySelectorAll("[data-price-wrapper]") || []
      ).map((priceWrapper) => ({
        self: priceWrapper,
        priceEl: priceWrapper.querySelector("[data-product-price]"),
        comparePriceEl: priceWrapper.querySelector("[data-compare-price]"),
        priceOffEl: priceWrapper.querySelector("[data-price-off]"),
      }));

      this.mediaGallery = (
        this.closest(".wrapper") || this.closest(".popup-quick-view__wrapper")
      )?.querySelector("[data-product-single-media-group]");
      this.dataVariantImagesJson = this.closest(".wrapper")?.querySelectorAll("[data-variant-images-json-handle]") || [];
      this.dataIsDefaultMedia = this.closest(".wrapper")?.querySelector("[data-is-default-media]") || null;
      this.dataProductMediaJson = this.closest(".wrapper")?.querySelector("[data-product-media-json]") || null;
      if (this.mediaGallery) {
        this.mediaSlider = this.mediaGallery.querySelector(
          "[data-product-single-media-slider]"
        );
        this.mediaThumbs = this.mediaGallery.querySelector(
          "[data-product-single-media-thumbs]"
        );
        this.mediaSlider = {
          el: this.mediaSlider,
          slides: Array.from(
            this.mediaSlider.querySelectorAll(
              "[data-product-single-media-wrapper]"
            )
          ),
          hidden: [],
        };
        this.mediaThumbs = this.mediaThumbs
          ? {
              el: this.mediaThumbs,
              thumbs: Array.from(
                this.mediaThumbs.querySelectorAll(".product-single__thumbnail")
              ),
              hidden: [],
            }
          : null;
      }

      if (!bundle) {
        this.init();
      }

      this.updateMediaGallery = this.updateMediaGallery.bind(this);
      this.updateCustomMediaGallery = this.updateCustomMediaGallery.bind(this);
    }

    init() {
      if (this.variantSelector.self) {
        let preSelectedOption = this.variantSelector.options.find(
          (option) => option.value === this.variantSelector.self.value
        );
  
        if (
          preSelectedOption &&
          preSelectedOption.text.toLowerCase() !== "select size"
        ) {
          const selectValueEl = this.variantSelector.self
            .closest(".select-wrapper")
            .querySelector("#SelectValue");
          selectValueEl.innerHTML = preSelectedOption.text;
          selectValueEl.classList.add("selected");

          const stickySelectValueEl = this.stickyVariantSelector.self
            .closest(".select-wrapper")
            .querySelector("#StickySelectValue");
          stickySelectValueEl.innerHTML = preSelectedOption.text;
          stickySelectValueEl.classList.add("selected");
        }

        if (this.dataIsDefaultMedia && this.dataIsDefaultMedia.getAttribute("data-is-default-media") === "true") {
          const variantId = this.dataIsDefaultMedia.getAttribute("data-variant-id");

          preSelectedOption = this.variantSelector.options.find(
            (option) => option.value === variantId
          );
        }
  
        if (
          // preSelectedOption?.dataset.originalVariantHandle &&
          this.mediaGallery
        ) {
          if (window.innerWidth <= 767) {
            let timeElapsed = 0;
            const interval = setInterval(() => {
              if (
                this.mediaGallery.querySelectorAll(".flickity-enabled").length ===
                2
              ) {
                this.updateMediaGallery(
                  preSelectedOption.dataset.variantTitle,
                  preSelectedOption.dataset.originalVariantHandle,
                  preSelectedOption.dataset.variantHandle
                );
                this.updateCustomMediaGallery(
                  preSelectedOption.dataset.variantTitle,
                  preSelectedOption.dataset.originalVariantHandle,
                  preSelectedOption.dataset.variantHandle
                );
                clearInterval(interval);
              }
  
              if (timeElapsed > 5000) clearInterval(interval);
  
              timeElapsed += 200;
            }, 200);
          } else {
            setTimeout(() => {
              this.updateMediaGallery(
                preSelectedOption.dataset.variantTitle,
                preSelectedOption.dataset.originalVariantHandle,
                preSelectedOption.dataset.variantHandle
              );
              this.updateCustomMediaGallery(
                preSelectedOption.dataset.variantTitle,
                preSelectedOption.dataset.originalVariantHandle,
                preSelectedOption.dataset.variantHandle
              );
            }, 200);
          }
        }
  
        // Helper function to handle variant changes
        const handleVariantChange = (selector, options, selectValueId, isSticky = false) => {
          const selectedName = selector.options[selector.selectedIndex].text;
          const selectedValue = selector.value;
          const selectedOption = options.find(
            (option) => option.value === selectedValue
          );
          if (!selectedOption) return;

          const selectValueEl = selector
            .closest(".select-wrapper")
            .querySelector(selectValueId);
          selectValueEl.innerHTML = selectedName;
          if (!selectValueEl.classList.contains("selected")) {
            selectValueEl.classList.add("selected");
          }

          // Sync other selector
          const otherSelector = isSticky ? this.variantSelector.self : this.stickyVariantSelector.self;
          const otherSelectValueId = isSticky ? "#SelectValue" : "#StickySelectValue";

          if (otherSelector && otherSelector.value !== selectedValue) {
            otherSelector.value = selectedValue;
            const otherSelectValueEl = otherSelector
              .closest(".select-wrapper")
              .querySelector(otherSelectValueId);
            if (otherSelectValueEl) {
              otherSelectValueEl.innerHTML = selectedName;
              if (!otherSelectValueEl.classList.contains("selected")) {
                otherSelectValueEl.classList.add("selected");
              }
            }
          }

          const atcLabel = selectedOption.dataset.atcLabel;
          const variantTitle = selectedOption.dataset.variantTitle;
          const variantHandle = selectedOption.dataset.originalVariantHandle;
          const variantHandle2 = selectedOption.dataset.variantHandle;

          this.updateMediaGallery(variantTitle, variantHandle, variantHandle2);

          this.updateCustomMediaGallery(variantTitle, variantHandle, variantHandle2);

          this.wrapper
            ?.querySelector("product-swatches")
            ?.handleVariantChange(
              selectedOption.dataset.variantHandle,
              selectedOption.value
            );

          this.updateAtcButton(
            "single",
            selectedOption.dataset.soldOut === "true",
            selectedOption.dataset.soldOutButtonLabel,
            atcLabel
          );

          this.updateBisPopupSelection(selectedValue);

          this.updateBisButton(
            selectedOption.dataset.soldOut === "true" &&
              !selectedOption.dataset.bisHidden,
            selectedOption.dataset.bisButtonLabel
          );
          this.updatePriceWrappers(
            "single",
            selectedOption.dataset.price,
            selectedOption.dataset.comparePrice,
            selectedOption.dataset.priceOff
          );

          this.updateWishlistButton(selectedOption.dataset.wishlistButton);

          if (this.remainingStockWrapper) {
            const stock = Number(selectedOption.dataset.stock);
            this.updateRemainingStockWrapper(stock);
          }

          const searchParams = new URLSearchParams(window.location.search);
          searchParams.set("variant", selectedOption.value);

          window.history.replaceState(
            null,
            "",
            window.location.pathname + "?" + searchParams.toString()
          );
        };

        this.variantSelector.self.addEventListener("change", () => {
          handleVariantChange(
            this.variantSelector.self,
            this.variantSelector.options,
            "#SelectValue",
            false
          );
        });

        if (this.stickyVariantSelector.self) {
          this.stickyVariantSelector.self.addEventListener("change", () => {
            handleVariantChange(
              this.stickyVariantSelector.self,
              this.stickyVariantSelector.options,
              "#StickySelectValue",
              true
            );
          });

          this.stickyAtcButton.addEventListener("click", () => {
            this.atcButton.click();
            this.stickyAtcButton.classList.add('is-loading');

            setTimeout(() => {
              this.stickyAtcButton.classList.remove('is-loading');
            }, 2500);
          });

          // Create an observer to show/hide sticky variant selector only on media <= 1024px
          if (window.innerWidth <= 1024) {
            const stickyObserver = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.stickyVariantSelector.self.closest('.sticky-atc').style.display = 'none';
                } else {
                  this.stickyVariantSelector.self.closest('.sticky-atc').style.display = 'flex';
                }
              });
            }, {
              threshold: 0.1,
              rootMargin: '-20px 0px 0px 0px'
            });

            const footer = document.querySelector('footer#SiteFooter');

            // Also observe the footer to hide sticky ATC when footer is visible
            if (footer) {
              stickyObserver.observe(footer);
            }

            // Observe the ATC button
            if (this.form) {
              stickyObserver.observe(this.form);
            }
          }
        }
      } else if (this.variantSquareOptions.length) {
        let preSelectedOption
        this.variantSquareOptions.forEach((option) => {
          if (option.checked) {
            preSelectedOption = option;
          }
        });

        if (
          // preSelectedOption?.dataset.originalVariantHandle &&
          this.mediaGallery
        ) {
          if (window.innerWidth <= 767) {
            let timeElapsed = 0;
            const interval = setInterval(() => {
              if (
                this.mediaGallery.querySelectorAll(".flickity-enabled").length ===
                2
              ) {
                this.updateMediaGallery(
                  preSelectedOption.dataset.variantTitle,
                  preSelectedOption.dataset.originalVariantHandle,
                  preSelectedOption.dataset.variantHandle
                );
                clearInterval(interval);
              }
  
              if (timeElapsed > 5000) clearInterval(interval);
  
              timeElapsed += 200;
            }, 200);
          } else {
            setTimeout(() => {
              this.updateMediaGallery(
                preSelectedOption.dataset.variantTitle,
                preSelectedOption.dataset.originalVariantHandle,
                preSelectedOption.dataset.variantHandle
              );
            }, 200);
          }
        }

        // listen to change event on radio buttons
        this.variantSquareOptions.forEach((option) => {
          if (option.checked) {
            option.closest('.product-option-square').classList.add('selected');
          }
      
          if (option.disabled) {
            option.closest('.product-option-square').classList.add('disabled');
          }

          option.addEventListener("change", () => {
            const selectedOption = option;
            if (!selectedOption) return;

            this.variantSquareOptions.forEach((option) => {
              option.closest('.product-option-square').classList.remove('selected');
            });
            selectedOption.closest('.product-option-square').classList.add('selected');
    
            const atcLabel = selectedOption.dataset.atcLabel;
    
            const variantTitle = selectedOption.dataset.variantTitle;
            const variantHandle = selectedOption.dataset.originalVariantHandle;
            const variantHandle2 = selectedOption.dataset.variantHandle;
    
            this.updateMediaGallery(variantTitle, variantHandle, variantHandle2);
    
            this.wrapper
              ?.querySelector("product-swatches")
              ?.handleVariantChange(
                selectedOption.dataset.variantHandle,
                selectedOption.value
              );
    
            this.updateAtcButton(
              "single",
              selectedOption.dataset.soldOut === "true",
              selectedOption.dataset.soldOutButtonLabel,
              atcLabel
            );
    
            this.updateBisPopupSelection(selectedOption.value);
    
            this.updateBisButton(
              selectedOption.dataset.soldOut === "true" &&
                !selectedOption.dataset.bisHidden,
              selectedOption.dataset.bisButtonLabel
            );

            this.updatePriceWrappers(
              "single",
              selectedOption.dataset.price,
              selectedOption.dataset.comparePrice,
              selectedOption.dataset.priceOff
            );
    
            this.updateWishlistButton(selectedOption.dataset.wishlistButton);
    
            if (this.remainingStockWrapper) {
              const stock = Number(selectedOption.dataset.stock);
              this.updateRemainingStockWrapper(stock);
            }
    
            const searchParams = new URLSearchParams(window.location.search);
            searchParams.set("variant", selectedOption.value);
    
            window.history.replaceState(
              null,
              "",
              window.location.pathname + "?" + searchParams.toString()
            );
          });
        });
      }
      this.bisButton?.addEventListener("click", () => {
        this.bisPopup.activate();
      });
    }

    updatePriceWrappers(type, price = "", comparePrice = "", priceOff = "") {
      this.priceWrappers.forEach((priceWrapper) => {
        priceWrapper.priceEl.innerText = price;
        priceWrapper.comparePriceEl.innerText = comparePrice;
        if (priceWrapper.priceOffEl) {
          priceWrapper.priceOffEl.querySelector(
            "[data-price-off-amount]"
          ).innerText = priceOff;
        }

        priceWrapper.comparePriceEl.classList.toggle("hidden", !comparePrice);
        priceWrapper.priceOffEl?.classList.toggle(
          "hidden",
          !priceOff ||
            // !window.theme.settings.showSavingBadge
            (((type === "single" &&
              !window.theme.settings.showSavingBadgeProductSingle) ||
              (type === "bundle" &&
                !window.theme.settings.showSavingBadgeProductBundle)) &&
              !window.theme.settings.showSaleBadge)
        );
      });
    }

    updateRemainingStockWrapper(stock) {
      const className =
        "count-is-" + (stock <= 5 ? "out" : stock <= 10 ? "low" : "in");
      this.remainingStockWrapper.classList = `variant__countdown ${className}`;
    }

    updateAtcButton(type, soldOut, soldOutLabel, atcLabel) {
      const textContainer = this.atcButton.querySelector(
        "[data-add-to-cart-text]"
      );
      const stickyTextContainer = this.stickyAtcButton?.querySelector(
        "[data-add-to-cart-text]"
      );

      if (soldOut) {
        textContainer.innerText = soldOutLabel;
        if(stickyTextContainer) stickyTextContainer.innerText = soldOutLabel;
        this.atcButton.setAttribute("disabled", "disabled");
        this.stickyAtcButton?.setAttribute("disabled", "disabled");
        if (type === "single") {
          this.atcButton.classList.add("hidden");
          this.stickyAtcButton?.classList.add("hidden");
          this.querySelector(".GiftWizard-gift-button")?.classList?.add?.(
            "hidden"
          );
        } else {
          this.atcButton.classList.remove("hidden");
          this.stickyAtcButton?.classList.remove("hidden");
        }
      } else {
        textContainer.innerText = atcLabel || "Add to cart";
        if(stickyTextContainer) stickyTextContainer.innerText = atcLabel || "Add to cart";
        this.atcButton.removeAttribute("disabled");
        this.atcButton.classList.remove("hidden");
        this.stickyAtcButton?.removeAttribute("disabled");
        this.stickyAtcButton?.classList.remove("hidden");
        this.querySelector(".GiftWizard-gift-button")?.classList?.remove?.(
          "hidden"
        );
      }
    }

    updateBisButton(soldOut, label) {
      if (!this.bisButton) return;
      if (soldOut) {
        this.bisButton.innerText = label;
        this.bisButton.removeAttribute("disabled");
      } else {
        this.bisButton.setAttribute("disabled", "disabled");
      }
    }

    updateBisPopupSelection(selectedValue) {
      if (!this.bisPopup) return;
      this.bisPopup.querySelector('[name="variant_id"]').value = selectedValue;
    }

    updateWishlistButton(wishlistButton) {
      if (this.wishlistButton && wishlistButton) {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = wishlistButton;
        const newWishListButton = wrapper.querySelector("cs-wishlist-button");
        this.wishlistButton.parentElement.replaceChild(
          newWishListButton,
          this.wishlistButton
        );
        this.wishlistButton = newWishListButton;
      }
    }

    updateMediaGallery(variantTitle, variantHandle, variantHandle2) {
      const defaultMediaIndexes = JSON.parse(this.mediaGallery.dataset.defaultMedia);
      console.log({defaultMediaIndexes})

      const isAirpodsPage = this.dataset.productType === "Airpods Pouch";

      if (!variantHandle && !variantHandle2) {
        if ( defaultMediaIndexes !== null || isAirpodsPage) {
          const imagesToShow = 5;

          let flickitySlides = null;
          let flickityThumbs = null;

          if (this.mediaSlider) {
            const mediaSliderSorted = [...this.mediaSlider?.slides].sort(
              (a, b) =>
                parseInt(a.dataset.defaultPosition) -
                parseInt(b.dataset.defaultPosition)
            );

            // console.log(mediaSliderSorted)
            let slidesToShow = [];
            let slidesToHide = [];

            if ( isAirpodsPage && defaultMediaIndexes == null ) {
              slidesToShow =
                mediaSliderSorted?.slice?.(0, imagesToShow) ?? [];
              slidesToHide =
                mediaSliderSorted?.slice?.(
                  imagesToShow,
                  this.mediaSlider?.slides.length
                ) ?? [];
            } else {
              defaultMediaIndexes.forEach((i) => {
                if ( mediaSliderSorted[i-1] ) {
                  slidesToShow.push(mediaSliderSorted[i-1]);
                }
              })

              mediaSliderSorted.forEach((item, index) => {
                if ( !defaultMediaIndexes.includes(index+1) ) {
                  slidesToHide.push(item)
                }
              })
            }

            flickitySlides = themeVendor.Flickity.data(this.mediaSlider.el);

            flickitySlides?.remove(this.mediaSlider?.slides ?? []);

            slidesToShow.forEach((slide, idx) => {
              flickitySlides?.insert([slide], idx);
            });

            if (!flickitySlides) {
              this.mediaSlider.el.replaceChildren(...slidesToShow);
            }

            slidesToHide?.forEach((_, idx) => {
              this.mediaSlider.hidden.push(imagesToShow + idx);
            });
          } else {
            return;
          }

          if (this.mediaThumbs) {
            const mediaThumbsSorted = [...this.mediaThumbs?.thumbs].sort(
              (a, b) =>
                parseInt(a.dataset.defaultPosition) -
                parseInt(b.dataset.defaultPosition)
            );

            let thumbsToShow = [];
            
            if ( isAirpodsPage && defaultMediaIndexes == null ) {
              thumbsToShow = mediaThumbsSorted?.slice?.(0, imagesToShow) ?? [];
            } else {
              defaultMediaIndexes.forEach((i) => {
                if ( mediaThumbsSorted[i-1] ) {
                  thumbsToShow.push(mediaThumbsSorted[i-1]);
                }
              })
            }

            flickityThumbs = themeVendor.Flickity.data(this.mediaThumbs.el);

            flickityThumbs?.remove(this.mediaThumbs?.thumbs ?? []);

            thumbsToShow.forEach((thumb, idx) => {
              flickityThumbs?.insert([thumb], idx);
            });

            if (!flickityThumbs && this.mediaThumbs) {
              this.mediaThumbs.el.replaceChildren(...thumbsToShow);
            }
          }

          if (flickitySlides) {
            setTimeout(() => {
              flickitySlides.resize();
            }, 250);
          }
          if (flickityThumbs) {
            setTimeout(() => {
              flickityThumbs.resize();
            }, 250);
          }
        }
        return;
      }

      let flickitySlides = null;
      let flickityThumbs = null;

      /* Set media slider & thumbnails slider to default state - Start */
      if (this.mediaSlider) {
        flickitySlides = themeVendor.Flickity.data(this.mediaSlider.el);

        flickitySlides?.remove(this.mediaSlider?.slides ?? []);

        this.mediaSlider?.slides.forEach((slide, idx) => {
          flickitySlides?.insert([slide], idx);
        });

        if (!flickitySlides) {
          this.mediaSlider.el.replaceChildren(...this.mediaSlider.slides);
        }

        this.mediaSlider.hidden = [];

        if (flickitySlides) {
          setTimeout(() => {
            flickitySlides.resize();
          }, 250);
        }
        if (flickityThumbs) {
          setTimeout(() => {
            flickityThumbs.resize();
          }, 250);
        }
      } else {
        return;
      }
      if (this.mediaThumbs) {
        flickityThumbs = themeVendor.Flickity.data(this.mediaThumbs.el);

        flickityThumbs?.remove(this.mediaThumbs?.thumbs ?? []);

        this.mediaThumbs?.thumbs.forEach((thumb, idx) => {
          flickityThumbs?.insert([thumb], idx);
        });

        if (!flickityThumbs) {
          this.mediaThumbs.el.replaceChildren(...this.mediaThumbs.thumbs);
        }
      }
      /* Set media slider & thumbnails slider to default state - End */

      if (this.mediaSlider?.hidden.length) {
        this.mediaSlider.hidden.forEach((idx) => {
          flickitySlides?.insert([this.mediaSlider.slides[idx]], idx);
          flickityThumbs?.insert([this.mediaThumbs?.thumbs[idx]], idx);
        });
        this.mediaSlider.hidden.length = 0;
      }

      const match = this.mediaSlider.slides.find(
        (slide) =>
          slide.dataset.variantHandle === variantHandle  ||
          slide.dataset.variantHandle === variantHandle2 ||
          slide.dataset.variantTitle === variantTitle
      );

      if (match) {
        const slidesToRemove = [];
        const thumbsToRemove = [];
        const slidesToShow = [];
        const thumbsToShow = [];

        this.mediaSlider.slides.forEach((slide, idx) => {
          if (
            slide.dataset.variantHandle !== variantHandle && 
            slide.dataset.variantHandle !== variantHandle2 &&
            slide.dataset.variantTitle !== variantTitle
          ) {
            slidesToRemove.push(slide);
            thumbsToRemove.push(this.mediaThumbs?.thumbs[idx]);
            this.mediaSlider.hidden.push(idx);
          } else {
            if (slide.dataset.featuredMedia === "true") {
              slidesToShow.unshift(slide);
              thumbsToShow.unshift(this.mediaThumbs?.thumbs[idx]);
            } else {
              slidesToShow.push(slide);
              thumbsToShow.push(this.mediaThumbs?.thumbs[idx]);
            }
          }
        });

        flickitySlides?.remove(this.mediaSlider?.slides ?? []);
        slidesToShow.forEach((slide, idx) => {
          flickitySlides?.insert([slide], idx);
        });

        if (!flickitySlides) {
          this.mediaSlider.el.replaceChildren(...slidesToShow);
        }

        flickityThumbs?.remove(this.mediaThumbs?.thumbs ?? []);
        thumbsToShow.forEach((thumb, idx) => {
          flickityThumbs?.insert([thumb], idx);
        });

        if (!flickityThumbs && this.mediaThumbs) {
          this.mediaThumbs.el.replaceChildren(...thumbsToShow);
        }
      }

      if (flickitySlides) {
        setTimeout(() => {
          flickitySlides.resize();
        }, 250);
      }
      if (flickityThumbs) {
        setTimeout(() => {
          flickityThumbs.resize();
        }, 250);
      }
    }

    updateCustomMediaGallery(variantTitle, variantHandle, variantHandle2) {
      if (!this.dataVariantImagesJson.length && !this.dataProductMediaJson) return;

      const variantImagesScript = Array.from(this.dataVariantImagesJson).find(
        (json) => json.dataset.variantImagesJsonHandle === variantHandle
      );

      let flickitySlides = null;
      let flickityThumbs = null;
      flickitySlides = themeVendor.Flickity.data(this.mediaSlider.el);
      flickityThumbs = themeVendor.Flickity.data(this.mediaThumbs.el);

      if (flickitySlides && flickityThumbs) {
        flickitySlides.destroy();
        flickityThumbs.destroy();
      }

      function safeParseJson(jsonString, fallback = []) {
        try {
          const parsed = JSON.parse(jsonString);
          return parsed || fallback;
        } catch (e) {
          return fallback;
        }
      }

      const usedSlideIds = new Set(), usedThumbIds = new Set();

      function getUniqueId(baseId, usedSet) {
        let id = baseId;
        let count = 1;
        while (usedSet.has(id)) {
          id = `${baseId}-${count++}`;
        }
        usedSet.add(id);
        return id;
      }

      function createSlide({ media, idx, isMedia = false }) {
        const id = media.id || idx;
        const src = (media.src || media.preview_image?.src || "").replace(/^\/\//, "https://");
        const alt = media.alt || "";
        const media_type = media.media_type || "image";

        const baseId = isMedia ? `product-media-${id || idx}` : `custom-variant-image-${idx}`;
        const slideId = getUniqueId(baseId, usedSlideIds);

        const slide = document.createElement("div");
        slide.className = "product-single__media-slide";
        slide.setAttribute("data-id", slideId);
        slide.setAttribute("data-media-id", slideId);
        slide.setAttribute("data-product-single-media-wrapper", "");

        const mediaWrapper = document.createElement("div");
        mediaWrapper.className = `product-single__media deferred-media product-single__media--${media_type}`;

        // Helper to set multiple attributes
        function setAttributes(el, attrs) {
          for (const key in attrs) {
            if (attrs[key] !== undefined && attrs[key] !== null) {
              el.setAttribute(key, attrs[key]);
            }
          }
        }

        if (media_type === "video") {
          mediaWrapper.style.paddingTop = "100%";

          const video = document.createElement("video");
          setAttributes(video, {
            poster: media.preview_image?.src || "",
            controls: true,
            autoplay: true,
            loop: true,
            muted: true,
            playsinline: true,
            class: "media-video",
            'aria-label': alt || "Product video"
          });

          // Add fallback text for accessibility
          video.textContent = alt || "Your browser does not support the video tag.";

          if (Array.isArray(media.sources)) {
            media.sources.forEach(sourceObj => {
              if (sourceObj && sourceObj.url) {
                const source = document.createElement("source");
                setAttributes(source, {
                  src: sourceObj.url,
                  type: sourceObj.mime_type || undefined
                });
                video.appendChild(source);
              }
            });
          }

          mediaWrapper.appendChild(video);
        } else {
          // Image
          const mediaDiv = document.createElement("div");
          mediaDiv.style.paddingTop = "100%";
          mediaDiv.className = "product-single__media--image-height";

          const figure = document.createElement("figure");
          figure.className = "lazy-image lazy-image--cover";

          const img = document.createElement("img");
          img.className = "product-single__media--image-height";
          img.src = src;
          img.alt = alt || "";
          img.loading = "lazy";
          img.style.width = "100%";
          img.style.height = "auto";

          const link = document.createElement("a");
          link.href = src;
          link.classList.add("product-single__media-link");
          setAttributes(link, {
            "aria-label": alt || "",
            "data-zoom-wrapper": "",
            rel: "lightbox",
            "data-image-width": media.width || "1500",
            "data-image-height": media.height || "1500",
            tabindex: "0"
          });

          link.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
              link.click();
            }
          });

          figure.appendChild(img);
          mediaWrapper.appendChild(mediaDiv);
          mediaWrapper.appendChild(figure);
          mediaWrapper.appendChild(link);
        }

        slide.appendChild(mediaWrapper);

        return slide;
      }

      function createCustomImageSlide(url, idx, alt) {
        let mediaObj;

        if (typeof url === 'string') {
          mediaObj = {
            src: url.replace(/^\/\//, "https://"),
            alt: alt || "",
            media_type: "image",
          };
        } else {
          mediaObj = url;
        }

        return createSlide({
          media: mediaObj,
          idx,
          isMedia: false,
        });
      }

      function createProductMediaSlide(media, idx) {
        return createSlide({
          media,
          idx,
          isMedia: true,
        });
      }

      function createThumb({ src, id, idx, alt, isMedia = false }) {
        const baseId = isMedia ? `product-media-${id || idx}` : `custom-variant-image-${idx}`;
        const thumbId = getUniqueId(baseId, usedThumbIds);

        const thumb = document.createElement("div");
        thumb.className = "product-single__thumbnail";
        thumb.setAttribute("data-id", thumbId);
        thumb.setAttribute("data-media-id", thumbId);

        const link = document.createElement("a");
        link.href = src;
        link.classList.add("product-single__thumbnail-link");
        link.setAttribute("aria-label", alt || "");
        thumb.appendChild(link);

        const figure = document.createElement("figure");
        figure.className = "lazy-image lazy-image--cover";

        const img = document.createElement("img");
        img.className = "product-single__thumbnail-img";
        img.src = src;
        img.alt = alt || "";
        img.loading = "lazy";
        img.style.width = "178";
        img.style.height = "178";

        figure.appendChild(img);
        link.appendChild(figure);

        return thumb;
      }

      function createCustomImageThumb(url, idx, alt) {
        let src;

        if (typeof url === 'string') {
          src = url.replace(/^\/\//, "https://");
        } else {
          src = url.preview_image?.src.replace(/^\/\//, "https://");
        }

        return createThumb({
          src,
          idx,
          alt,
          isMedia: false,
        });
      }

      function createProductMediaThumb(media, idx, alt) {
        const id = media.id || idx;
        const src = (media.src || media.preview_image?.src || "").replace(/^\/\//, "https://");
        return createThumb({
          src,
          id,
          idx,
          alt,
          isMedia: true,
        });
      }

      function initGalleryFlickity(sliderEl, thumbsEl, slidesCount) {
        if (slidesCount > 1) {
          new themeVendor.Flickity(sliderEl, {
            wrapAround: true,
            pageDots: false,
            adaptiveHeight: true,
            cellAlign: "left",
            on: {
              dragStart: () => {
                sliderEl.classList.add(classes$zCustom.isMoving);
              },
              settle: (index) => {
                sliderEl.classList.remove(classes$zCustom.isMoving);
              }
            }
          });
          new themeVendor.Flickity(thumbsEl, {
            asNavFor: sliderEl,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            resize: true,
          });

          const thumbLinks = thumbsEl.querySelectorAll(".product-single__thumbnail-link");

          if (thumbLinks.length) {
            thumbLinks.forEach((el) => {
              el.addEventListener("click", (e) => {
                e.preventDefault();
              });
            });
          }

          const videoElements = sliderEl.querySelectorAll("video");
          if (videoElements.length) {
            videoElements.forEach((video) => {
              video.play();
            });
          }
        }
      }

      const parseMediaData = (el) => {
        if (!el) return null;
        const text = el.textContent || el.innerText;
        return safeParseJson(text, []);
      };

      const renderGallery = (slides, thumbs) => {
        this.mediaSlider.el.replaceChildren(...slides);
        this.mediaThumbs.el.replaceChildren(...thumbs);

        if (window.innerWidth < 768) {
          initGalleryFlickity(this.mediaSlider.el, this.mediaThumbs.el, slides.length);
        }

        const productSection = document.querySelector("[data-section-type='product-template']");
        new ZoomCustom(productSection);
      };

      let slides = [], thumbs = [];

      if (variantImagesScript) {
        const imageUrls = parseMediaData(variantImagesScript);
        if (Array.isArray(imageUrls) && imageUrls.length) {
          slides = imageUrls.map((url, idx) => createCustomImageSlide(url, idx, variantTitle));
          thumbs = imageUrls.map((url, idx) => createCustomImageThumb(url, idx, variantTitle));
          renderGallery(slides, thumbs);
        }
      } else if (this.dataProductMediaJson) {
        const mediaJson = parseMediaData(this.dataProductMediaJson);
        if (Array.isArray(mediaJson) && mediaJson.length) {
          slides = mediaJson.map((media, idx) => createProductMediaSlide(media, idx));
          thumbs = mediaJson.map((media, idx) => createProductMediaThumb(media, idx, variantTitle));
          renderGallery(slides, thumbs);
        }
      }
    }
  }

  customElements.define("atc-form", ATCForm);

  class ATCFormBundle extends ATCForm {
    constructor() {
      super(true);
      this.variantSelectors = Array.from(this.querySelectorAll("select")).map(
        (selector) => ({
          self: selector,
          options: Array.from(selector.querySelectorAll("option")),
        })
      );
      // Product options in squares
      this.variantSquareOptions = this.querySelectorAll("input[type=radio]");

      this.discount = Number(this.dataset.discount || "0");
      this.containerPrice = Number(this.dataset.containerPrice || "0");
      this.containerComparePrice = Number(
        this.dataset.containerComparePrice || "0"
      );

      this.useContainerPrice = this.dataset.useContainerPrice === "true";
      // this.dynamicDiscount = !!this.dataset.dynamicDiscount;
      this.dynamicDiscount = this.dataset.dynamicDiscount === "true";
      this.init();
    }

    init() {
      if (this.variantSelectors.length) {
        this.variantSelectors.forEach((selector, index) => {
          const selectValueEl = selector.self
            .closest(".select-wrapper")
            .querySelector("#SelectValue");
  
          const preSelectedOption = selector.options.find(
            (option) => option.value === selector.self.value
          );
  
          if (
            preSelectedOption &&
            preSelectedOption.text.toLowerCase() !== "select size"
          ) {
            selectValueEl.innerHTML = preSelectedOption.text;
            selectValueEl.classList.add("selected");
          }
  
          selector.self.addEventListener("change", () => {
            const selectedOptions = this.variantSelectors.map((selector) => {
              const value = selector.self.value;
              return (
                value &&
                selector.options?.find((option) => option.value === value)
              );
            });
  
            const selectedName =
              selector.self.options[selector.self.selectedIndex].text;
            selectValueEl.innerHTML = selectedName;
            if (!selectValueEl.classList.contains("selected")) {
              selectValueEl.classList.add("selected");
            }
  
            if (selectedOptions.some((option) => !Boolean(option))) return;
  
            const soldOut = selectedOptions.some(
              (option) => option.dataset.soldOut === "true"
            );
  
            this.updateAtcButton("bundle", soldOut, "Sold out", "");
  
            const totalPrice = selectedOptions.reduce((acc, option) => {
              return (acc += Number(option.dataset.price));
            }, 0);
  
            let discountedPrice;
  
            if (this.dynamicDiscount) {
              if (this.containerPrice < totalPrice) {
                discountedPrice = this.containerPrice;
                this.querySelector('input[name="dsc"]').value =
                  ((totalPrice - discountedPrice) / totalPrice) * 100;
              } else {
                this.querySelector('input[name="dsc"]').value = 0;
                discountedPrice = totalPrice;
              }
            } else {
              discountedPrice =
                totalPrice * ((100 - Number(this.discount)) / 100);
            }
  
            if (this.useContainerPrice && this.dynamicDiscount) {
              this.updatePriceWrappers(
                "bundle",
                window.formatMoney(this.containerPrice),
                this.containerPrice < this.containerComparePrice
                  ? window.formatMoney(this.containerComparePrice)
                  : "",
                this.containerPrice < this.containerComparePrice
                  ? window.formatMoney(
                      this.containerComparePrice - this.containerPrice
                    )
                  : ""
              );
            } else {
              this.updatePriceWrappers(
                "bundle",
                window.formatMoney(discountedPrice),
                discountedPrice < totalPrice && !this.dynamicDiscount
                  ? window.formatMoney(totalPrice)
                  : "",
                discountedPrice < totalPrice && !this.dynamicDiscount
                  ? window.formatMoney(totalPrice - discountedPrice)
                  : ""
              );
            }
  
            if (this.remainingStockWrapper) {
              const stock = Math.min(
                ...selectedOptions.map((option) => Number(option.dataset.stock))
              );
              this.updateRemainingStockWrapper(stock);
            }
          });
        });
      } else if (this.variantSquareOptions.length) {
        this.variantSquareOptions.forEach((option) => {
          if (option.checked) {
            option.closest('.product-option-square').classList.add('selected');
          }

          if (option.disabled) {
            option.closest('.product-option-square').classList.add('disabled');
          }

          option.addEventListener("change", () => {
            let selectedOptions = []
            this.variantSquareOptions.forEach((option) => {
              option.closest('.product-option-square').classList.remove('selected');
              if (option.checked) {
                selectedOptions.push(option);
              }
            });
            option.closest('.product-option-square').classList.add('selected');
  
            if (selectedOptions.some((option) => !Boolean(option))) return;
  
            const soldOut = selectedOptions.some(
              (option) => option.dataset.soldOut === "true"
            );
  
            this.updateAtcButton("bundle", soldOut, "Sold out", "");
  
            const totalPrice = selectedOptions.reduce((acc, option) => {
              return (acc += Number(option.dataset.price));
            }, 0);
  
            let discountedPrice;
  
            if (this.dynamicDiscount) {
              if (this.containerPrice < totalPrice) {
                discountedPrice = this.containerPrice;
                this.querySelector('input[name="dsc"]').value =
                  ((totalPrice - discountedPrice) / totalPrice) * 100;
              } else {
                this.querySelector('input[name="dsc"]').value = 0;
                discountedPrice = totalPrice;
              }
            } else {
              discountedPrice =
                totalPrice * ((100 - Number(this.discount)) / 100);
            }
  
            if (this.useContainerPrice && this.dynamicDiscount) {
              this.updatePriceWrappers(
                "bundle",
                window.formatMoney(this.containerPrice),
                this.containerPrice < this.containerComparePrice
                  ? window.formatMoney(this.containerComparePrice)
                  : "",
                this.containerPrice < this.containerComparePrice
                  ? window.formatMoney(
                      this.containerComparePrice - this.containerPrice
                    )
                  : ""
              );
            } else {
              this.updatePriceWrappers(
                "bundle",
                window.formatMoney(discountedPrice),
                discountedPrice < totalPrice && !this.dynamicDiscount
                  ? window.formatMoney(totalPrice)
                  : "",
                discountedPrice < totalPrice && !this.dynamicDiscount
                  ? window.formatMoney(totalPrice - discountedPrice)
                  : ""
              );
            }
  
            if (this.remainingStockWrapper) {
              const stock = Math.min(
                ...selectedOptions.map((option) => Number(option.dataset.stock))
              );
              this.updateRemainingStockWrapper(stock);
            }
          });
        });
      }

    }
  }

  customElements.define("atc-form-bundle", ATCFormBundle);

  class CountrySelectorPopup extends HTMLElement {
    constructor() {
      super();

      this.triggers = document.querySelectorAll(
        "[data-country-selector-trigger]"
      );
      this.wrapper = this.querySelector("[data-popup-wrapper]");
      this.closeButton = this.querySelector("[data-close-button]");
      this.cancelButton = this.querySelector("[data-cancel-button]");

      this.triggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
          this.wrapper.setAttribute("data-active", true);
          document.documentElement.style.overflowY = "hidden";
        });
      });

      this.wrapper.addEventListener("click", (e) => {
        e.stopPropagation();
        if (
          e.target === e.currentTarget ||
          this.closeButton.contains(e.target) ||
          this.cancelButton.contains(e.target)
        ) {
          this.wrapper.removeAttribute("data-active");
          document.documentElement.style.overflowY = "unset";
        }
      });
    }
  }

  customElements.define("country-selector-popup", CountrySelectorPopup);

  class BackInStock extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.emailInput = this.form.querySelector('[name="email"]');
      this.productIdInput = this.form.querySelector('[name="product_id"]');
      this.variantIdInput = this.form.querySelector('[name="variant_id"]');
      this.marketingCheckbox = this.form.querySelector(
        '[name="accepts_marketing"]'
      );
      this.submitBtn = this.form.querySelector('button[type="submit"]');
      this.closeBtns = this.querySelectorAll(".js-close-btn");
      this.errorBox = this.querySelector(".js-error");

      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (
          !this.emailInput.value ||
          !this.productIdInput.value ||
          !this.variantIdInput.value
        ) {
          return;
        }

        this.submitBtn.setAttribute("disabled", "disabled");

        // BIS.create(
        //   this.emailInput.value,
        //   this.variantIdInput.value,
        //   this.productIdInput.value,
        //   { accepts_marketing: !!this.marketingCheckbox.checked }
        // ).then((res) => {
        //   if (res.status === "OK") {
        //     this.setAttribute("data-submitted", true);
        //   } else {
        //     this.errorBox.innerText =
        //       res.errors?.base || res.errors?.email || "Something went wrong.";
        //     this.submitBtn.removeAttribute("disabled");
        //   }
        // });

        let klaviyoKey = "eH8uTZ";

        let email = this.emailInput.value;
        let productId = this.productIdInput.value;
        let variantId = this.variantIdInput.value;

        if (!variantId) {
          variantId = productId;
        }

        const options = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2024-06-15",
          },
          body: JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                channels: ["EMAIL"],
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: email,
                    },
                  },
                },
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        };

        fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoKey}`,
          options
        )
          .then((response) => {
            // console.log(response)
            if (!response.ok) {
              throw new Error(`An error occurred: ${response.status}`);
            }

            return response.text();
          })
          .then((res) => {
            // console.log(res);
            this.setAttribute("data-submitted", true);
          })
          .catch((error) => {
            // console.log(error)
            this.errorBox.innerText = error.message || "Something went wrong.";
            this.submitBtn.removeAttribute("disabled");
          });
      });

      this.closeBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          document.querySelector("body").style.overflow = "unset";
          document.documentElement.style.overflow = "unset";
          this.removeAttribute("data-active");
          this.removeAttribute("data-submitted");
          this.submitBtn.removeAttribute("disabled");
          this.emailInput.value = "";
          this.marketingCheckbox.checked = true;
          this.errorBox.innerHTML = "";
        });
      });

      this.activate = this.activate.bind(this);
    }

    activate() {
      document.querySelector("body").style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      this.setAttribute("data-active", true);
    }
  }

  customElements.define("back-in-stock", BackInStock);

  class ProductSwatches extends HTMLElement {
    constructor() {
      super();

      this.swatches = this.querySelectorAll("[data-product-swatch]");
      this.activeSwatch = this.querySelector(
        '[data-product-swatch][data-active="true"]'
      );
      this.productCard = this.closest(".product-grid-item");
      this.label = this.productCard?.querySelector("[data-color-label]");
      this.productBadge = this.productCard?.querySelector(
        "[data-product-badge]"
      );
      this.productTitle = this.productCard?.querySelector(
        ".product-grid-item__title"
      );
      this.productPrice = this.productCard?.querySelector(
        ".product-grid-item__price"
      );
      this.featuredImage = this.productCard?.querySelector(
        "[data-product-image] img"
      );
      this.hoverImage = this.productCard?.querySelector(
        "[data-product-image-hover] img"
      );
      this.productLinks =
        this.productCard?.querySelectorAll("[data-grid-link]");
      this.wishlistButton =
        this.productCard?.querySelector("cs-wishlist-button");
      this.productRating = this.productCard?.querySelector(".yotpo.bottomLine");

      this.allShown = false;
      this.viewAllButton = this.querySelector("[data-view-all-button]");

      this.initHoverHandlers = this.initHoverHandlers.bind(this);
      this.initViewAllButton = this.initViewAllButton.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);

      this.initViewAllButton();
      if (this.productCard) {
        this.initHoverHandlers();
      }
    }

    initHoverHandlers() {
      this.swatches.forEach((swatch) => {
        const dataset = swatch.dataset;

        var productBadgeTempParent = document.createElement("div");
        productBadgeTempParent.innerHTML = swatch.dataset.productBadge.trim();
        const productBadge = productBadgeTempParent.firstChild;

        const productId = dataset.productId;
        const productTitle = dataset.productTitle;
        const swatchLabel = dataset.swatchLabel;
        const featuredImage = dataset.featuredImage;
        const hoverImage = dataset.hoverImage;
        const productPrice = dataset.productPrice;
        const wishlistButton = dataset.wishlistButton;
        const productRating = this.querySelector(`#product-rating-${productId} .yotpo.bottomLine`);
        const url = swatch.href;

        swatch.addEventListener("click", (e) => {
          e.preventDefault();

          this.activeSwatch.removeAttribute("data-active");
          this.activeSwatch = swatch;
          swatch.setAttribute("data-active", true);

          this.productLinks?.forEach((link) => {
            link.href = url;
          });

          if (this.label) {
            this.label.innerText = swatchLabel;
          }
          if (this.productBadge && productBadge)
            this.productBadge.innerHTML = productBadge.innerHTML;
          if (this.productTitle && productTitle)
            this.productTitle.innerText = productTitle;
          if (this.productPrice && productPrice)
            this.productPrice.innerHTML = productPrice;
          if (this.featuredImage && featuredImage) {
            this.featuredImage.removeAttribute("srcset");
            this.featuredImage.removeAttribute("sizes");
            this.featuredImage.setAttribute("src", featuredImage);
          }
          if (this.hoverImage && hoverImage) {
            this.hoverImage.removeAttribute("srcset");
            this.hoverImage.removeAttribute("sizes");
            this.hoverImage.setAttribute("src", hoverImage);
          }
          if (this.wishlistButton && wishlistButton) {
            // const unique_id = `sws-${Date.now()}`;
            // this.productCard.setAttribute("data-swymn-selector", unique_id);
            const wrapper = document.createElement("div");
            wrapper.innerHTML = wishlistButton;
            const newWishListButton =
              wrapper.querySelector("cs-wishlist-button");
            this.wishlistButton.parentElement.replaceChild(
              newWishListButton,
              this.wishlistButton
            );

            this.wishlistButton = newWishListButton;
          }
          console.log(this.productRating)
          console.log(productRating)
          if (this.productRating && productRating) {
            this.productRating?.parentElement?.replaceChild(
              productRating,
              this.productRating
            );
            
            this.productRating = productRating;
          }
        });
      });
    }

    initViewAllButton() {
      if ( !this.viewAllButton ) return;

      this.viewAllButton?.addEventListener("click", () => {
        this.allShown = true;
        this.viewAllButton.removeAttribute("data-active");
        this.swatches.forEach((swatch) => {
          swatch.classList.remove("--hidden");
        });
      });
    }

    handleVariantChange(variant_handle) {
      let availableCount = 0;
      this.swatches.forEach((swatch) => {
        const handlesAndIds = swatch
          .getAttribute("data-available-variant-handles-and-ids")
          ?.split(",");
        const matchingVariantId = handlesAndIds
          .find((handle) => handle?.split(":")?.[0] === variant_handle)
          ?.split(":")?.[1];
        if (variant_handle && !matchingVariantId) {
          swatch.classList.add("--unavailable");
        } else {
          swatch.classList.remove("--unavailable");
          swatch.setAttribute(
            "href",
            `${swatch.href.split("?variant")[0]}${
              matchingVariantId ? "?variant=" + matchingVariantId : ""
            }`
          );
          availableCount++;
        }
        swatch.classList.toggle(
          "--hidden",
          !this.allShown &&
            ((this.productCard && availableCount > 4) || availableCount > 8)
        );
      });
    
      if ( this.viewAllButton ) {
        this.viewAllButton.toggleAttribute(
          "data-active",
          !this.allShown &&
            ((this.productCard && availableCount > 4) || availableCount > 8)
        );
      }
    }
  }

  customElements.define("product-swatches", ProductSwatches);

  class ShoppableVideos extends HTMLElement {
    constructor() {
      super();
      this.imagesToReplace = Array.from(
        this.querySelectorAll("img[data-video-replacement]")
      )
        .map((img) => {
          const replacement = img.dataset.videoReplacement;
          if (replacement) {
            return {
              el: img,
              replacement,
            };
          }
        })
        .filter(Boolean);

      this.popupTriggers = this.querySelectorAll(
        "[data-shoppable-video-trigger]"
      );
      this.popups = Array.from(
        this.querySelectorAll("[data-shoppable-video-popup]")
      );
      this.popupsWrapper = this.querySelector("[data-popups]");
      this.activeVideo = null;

      this.watchTopDistances = this.watchTopDistances.bind(this);
      this.addEventListeners = this.addEventListeners.bind(this);
      this.removeEventListeners = this.removeEventListeners.bind(this);
      this.initializePopups = this.initializePopups.bind(this);
    }

    connectedCallback() {
      if (this.imagesToReplace.length) {
        this.watchTopDistances();
        this.addEventListeners();
      }
      this.initializePopups();
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }

    addEventListeners() {
      window.addEventListener("scroll", this.watchTopDistances);
      window.addEventListener("resize", this.watchTopDistances);
    }

    removeEventListeners() {
      window.removeEventListener("scroll", this.watchTopDistances);
      window.removeEventListener("resize", this.watchTopDistances);
    }

    watchTopDistances() {
      let remaining = [];
      this.imagesToReplace.forEach((img) => {
        const topDist = img.el.getBoundingClientRect().top;
        if (topDist < window.innerHeight + 100) {
          const wrapper = document.createElement("div");
          wrapper.innerHTML = img.replacement;
          const video = wrapper.querySelector("video");

          const maxDuration = Number(video.dataset.maxDuration);

          img.el.parentElement.replaceChild(video, img.el);

          if (!isNaN(maxDuration) && maxDuration > 0) {
            video.addEventListener("timeupdate", () => {
              if (video.currentTime > maxDuration) {
                video.currentTime = 0;
              }
            });
          }

          const videoWrapperWithCanvas = video.closest(
            "[data-video-wrapper-with-canvas]"
          );

          if (videoWrapperWithCanvas) {
            let v = video;
            let canvas = videoWrapperWithCanvas.querySelector("canvas");
            let context = canvas.getContext("2d");

            let draw = () => {
              var cw = canvas.clientWidth;
              var ch = canvas.clientHeight;
              canvas.width = cw;
              canvas.height = ch;
              if (v.paused || v.ended) return false;
              context.drawImage(v, 0, 0, cw, ch);
            };
            let loop;
            if ("requestVideoFrameCallback" in HTMLVideoElement.prototype) {
              loop = () => {
                v.requestVideoFrameCallback(() => {
                  draw();
                  loop();
                });
              };
            } else {
              loop = () => {
                requestAnimationFrame(() => {
                  draw();
                  loop();
                });
              };
            }

            loop();
          }
        } else {
          remaining.push(img);
        }
      });
      this.imagesToReplace = remaining;
      if (!this.imagesToReplace.length) {
        this.removeEventListeners();
      }
    }

    initializePopups() {
      this.popupTriggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
          const popup = this.popups.find(
            (popup) => popup.dataset.blockId === trigger.dataset.blockId
          );
          if (popup) {
            popup.setAttribute("data-active", "true");
            this.popupsWrapper.setAttribute("data-active", "true");
            popup.querySelector("video")?.play();
          }
        });
      });

      this.popups.forEach((popup, idx) => {
        const video = popup.querySelector("video");
        const productTriggers = popup.querySelectorAll(
          "[data-product-trigger]"
        );
        const productContainers = Array.from(
          popup.querySelectorAll("[data-product]")
        );
        video.addEventListener("load", () => {
          video.poster = null;
        });

        const productsContainer = popup.querySelector(
          "[data-products-container]"
        );
        const productsContainerClose = popup.querySelector(
          "[data-products-container-close-button]"
        );
        const mobileProductLinks = popup.querySelectorAll(
          "[data-mobile-product-link]"
        );
        const mobileViewAllProducts = popup.querySelector(
          "[data-mobile-view-all-products]"
        );

        const closeButton = popup.querySelector("[data-close-button]");
        const soundToggle = popup.querySelector("[data-sound-toggle]");
        const navButtons = popup.querySelectorAll("[data-nav-button]");

        closeButton.addEventListener("click", () => {
          video.pause();
          video.currentTime = 0.001;

          this.popupsWrapper.removeAttribute("data-active");
          popup.removeAttribute("data-active");
        });

        soundToggle.addEventListener("click", () => {
          if (soundToggle.dataset.muted) {
            soundToggle.removeAttribute("data-muted");
          } else {
            soundToggle.setAttribute("data-muted", "true");
          }
          video.muted = !video.muted;
        });

        navButtons.forEach((button) => {
          button.addEventListener("click", () => {
            let targetPopup = null;
            if (button.dataset.type === "next") {
              targetPopup =
                this.popups[idx === this.popups.length - 1 ? 0 : idx + 1];
            } else {
              targetPopup =
                this.popups[idx === 0 ? this.popups.length - 1 : idx - 1];
            }

            video.pause();
            video.currentTime = 0.001;
            targetPopup.setAttribute("data-active", "true");
            targetPopup.querySelector("video")?.play();
            popup.removeAttribute("data-active");
          });
        });

        productTriggers.forEach((trigger) => {
          const viewButton = trigger.querySelector("[data-view-button]");
          viewButton.addEventListener("click", () => {
            let productContainer = productContainers.find(
              (container) =>
                container.dataset.productId === trigger.dataset.productId
            );
            if (productContainer) {
              productContainer.setAttribute("data-active", true);
              if (window.innerWidth <= 767) {
                productsContainer.style.height = `${productContainer.offsetHeight}px`;
              }
            }
          });
        });

        productContainers.forEach((container) => {
          const backButton = container.querySelector("[data-back-button]");
          backButton.addEventListener("click", () => {
            container.removeAttribute("data-active", true);
            productsContainer.removeAttribute("style");
          });
        });

        productsContainerClose.addEventListener("click", () => {
          productsContainer.removeAttribute("data-active");
        });

        mobileProductLinks.forEach((link) => {
          link.addEventListener("click", () => {
            const product = productContainers.find(
              (container) =>
                container.dataset.productId === link.dataset.productId
            );
            if (product) {
              product.classList.add("--no-transition");
              product.setAttribute("data-active", true);
              productsContainer.setAttribute("data-active", true);
              productsContainer.style.height = `${product.offsetHeight}px`;
              setTimeout(() => {
                product.classList.remove("--no-transition");
              }, 0);
            }
          });
        });

        mobileViewAllProducts.addEventListener("click", () => {
          productsContainer.setAttribute("data-active", true);
        });
      });
    }
  }

  customElements.define("shoppable-videos", ShoppableVideos);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

// Hide extra custom links on the PDP
(() => {
  const links = document.querySelectorAll(".js-custom-link");

  links.forEach((link) => {
    link.style.display = "none";
  });

  const sizeLinksArray = Array.from(links).filter((link) =>
    link.closest(".custom-atc-form")
  );
  if (!sizeLinksArray.length) return;
  sizeLinksArray[0].style.display = "block";
})();

// Hide size guide button on the PDP when there is no size selector
(() => {
  const popupBlock = document.querySelector(".js-popup-for-size");

  if (!popupBlock) return;

  const sizeSelector = document.querySelectorAll(
    ".radio__fieldset:not(.--hidden)"
  );

  if (sizeSelector.length) {
    const iphoneOption = Array.from(
      sizeSelector[0].querySelectorAll("option")
    ).find((option) => option.innerText.toLowerCase().includes("iphone"));

    if (iphoneOption) {
      popupBlock.style.display = "block";
    } else {
      popupBlock.style.display = "none";
    }
  } else {
    popupBlock.style.display = "none";
  }
})();

// Create a wrapper and put all size guide popup images

(() => {
  const popupBlock = document.querySelector(".js-size-popup");

  if (!popupBlock) return;

  const sizeGuideImages = popupBlock.querySelectorAll("img");
  const wrapper = document.createElement("div");
  wrapper.classList.add("size-guide-images-wrapper");

  sizeGuideImages.forEach((image) => {
    wrapper.appendChild(image.parentElement);
  });

  popupBlock.querySelector(".product__popup__content").appendChild(wrapper);
})();